import { render, staticRenderFns } from "./ListSiswa.vue?vue&type=template&id=5098c855&scoped=true"
import script from "./ListSiswa.vue?vue&type=script&lang=js"
export * from "./ListSiswa.vue?vue&type=script&lang=js"
import style0 from "./ListSiswa.vue?vue&type=style&index=0&id=5098c855&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5098c855",
  null
  
)

export default component.exports